var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.2468267,14.9326933 C24.8356267,14.9326933 25.3134933,15.41056 25.3134933,15.99936 C25.3134933,16.58816 24.8356267,17.0660267 24.2468267,17.0660267 L17.06816,17.0660267 L17.06816,24.2446933 C17.06816,24.8356267 16.5902933,25.31136 16.0014933,25.31136 C15.41056,25.31136 14.9348267,24.8356267 14.9348267,24.2446933 L14.9348267,17.0660267 L7.75829333,17.0660267 C7.16736,17.0660267 6.69162667,16.58816 6.69162667,15.99936 C6.69162667,15.41056 7.16736,14.9326933 7.75829333,14.9326933 L14.9348267,14.9326933 L14.9348267,7.75616 C14.9348267,7.16522667 15.41056,6.68949333 16.0014933,6.68949333 C16.5902933,6.68949333 17.06816,7.16522667 17.06816,7.75616 L17.06816,14.9326933 L24.2468267,14.9326933 Z M27.3322667,23.9722667 C28.992,21.6170667 29.8666667,18.8608 29.8666667,16 C29.8666667,8.35413333 23.6458667,2.13333333 16,2.13333333 C8.35413333,2.13333333 2.13333333,8.35413333 2.13333333,16 C2.13333333,19.0272 3.09973333,21.8944 4.92373333,24.2944 C7.28746667,27.4816 10.8992,29.4869333 14.8352,29.8112 C15.7674667,29.9008 16.6656,29.8688 17.5381333,29.7749333 C21.4933333,29.3397333 25.0645333,27.2234667 27.3322667,23.9722667 Z M16,-1.0658141e-14 C24.8234667,-1.0658141e-14 32,7.17653333 32,16 C32,19.3045333 30.9909333,22.4853333 29.0773333,25.1968 C26.4618667,28.9514667 22.336,31.3941333 17.7706667,31.8954667 C17.1925333,31.9573333 16.5994667,32 16,32 C15.5498667,32 15.0997333,31.9786667 14.6474667,31.936 C10.112,31.5648 5.94133333,29.2458667 3.21706667,25.5765333 C1.11573333,22.8117333 0,19.4944 0,16 C0,7.17653333 7.17866667,-1.0658141e-14 16,-1.0658141e-14 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/plus--1stroke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/plus"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-5",
    fill: "#2A2A3A",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/#2B2A3A",
    mask: "url(#mask-2)",
    fill: "#2B2A3A"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.000000, -66.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 158,
    height: 162
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 9.000000)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/icon-plus-circle.d6270344ce3226dc71ffdc7b6aa6d82e.svg";
export { ForwardRef as ReactComponent };